import { useEffect, useState } from "react";
import { User } from "../services";

function useFetchLimit(fetchFn, processFn = data => data?.limit ?? null) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetchFn();
        setData(processFn(response.data));
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return { data, loading, error };
}

export function useOrderLimit() {
  const { data, loading, error } = useFetchLimit(User.getOrderLimit);
  return { orderLimit: data, loading, error };
}

export function useAirOrderLimit() {
  const { data, loading, error } = useFetchLimit(User.getAirOrderLimit);
  return { airOrderLimit: data, loading, error };
}

export function useUserLimits() {
  const processFn = (data) => ({
    employeeLimit: data?.employeeLimit ?? null,
    partnerLimit: data?.partnerLimit ?? null,
    marketplaceInvitationLimit: data?.marketplaceInvitationLimit ?? null
  });

  const { data, loading, error } = useFetchLimit(User.getUserLimit, processFn);
  return { ...data, loading, error };
}
